/* import __COLOCATED_TEMPLATE__ from './rails.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();